import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { useLang } from "@/i18n/LanguageContext";

export const Layout = () => {
  const { pathname } = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="min-h-screen bg-olime-bg text-olime-ink relative">
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
        <CookieBanner />
        <WhatsAppButton lang={lang} />
      </div>
    </ReactLenis>
  );
};
